<template>
  <b-container>
    <h4 class="text-center">Enter OTP within 5 minutes of receiving</h4>
    <b-form 
      v-on:submit.prevent="submitOTP">
      <b-form-group 
        id="OTPInputGroup" 
        label="OTP" 
        label-for="otpInput" 
        description="your one time pin (OTP)">
        <b-form-input 
          required
          id="otpInput" 
          type="text" 
          v-model="otp" 
          placeholder="Enter OTP">
        </b-form-input>
      </b-form-group>
      <b-button 
        block
        type="submit" 
        :disabled="waiting"
        variant="outline-primary" 
        size="lg">
        Submit <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
      </b-button>
    </b-form>
  </b-container>
</template>

<script>
import { authService } from '../_services';
export default {
  data() {
    return {
      waiting: false,
      otp: ''
    }
  },
  methods: {
    submitOTP() {
      let vm = this
      this.waiting = true
      authService.loginOTP(this.otp)
      .then((resp) => {
        this.waiting = false
        vm.$router.push({path: '/'})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/LoginOTPPage.vue